import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getErrorData, type IErrorData } from '@/utils/getErrorData';
import { updateOrderDelivery } from '@/hooks/orderOfferApi';
import { isError } from '@/utils/typeguards/isError';
import {
  type IUpdateOrderDeliveryPayload,
  type IUpdateOrderDeliveryResponse
} from '@/types/IUpdateOrderDelivery';

export interface IUpdateOrderRecipientParams {
  orderUuid: string;
  payload: IUpdateOrderDeliveryPayload;
}

export const updateOrderRecipientThunk = createAsyncThunk<
  IUpdateOrderDeliveryResponse,
  IUpdateOrderRecipientParams,
  { rejectValue: IErrorData }
>(
  'recipientEdit/updateOrderRecipient',
  async ({ orderUuid, payload }, { rejectWithValue }) => {
    try {
      const response = await updateOrderDelivery(orderUuid, payload);

      if (isError(response)) {
        toast.error(response.message);
        return rejectWithValue(response);
      }

      toast('Данные успешно обновлены', { type: 'success' });

      return response;
    } catch (error) {
      const errorData = getErrorData(error);
      toast.error(
        errorData.message ?? 'Произошла ошибка при сохранении данных получателя'
      );
      return rejectWithValue(errorData);
    }
  }
);
